module.exports = "<iframe ng-src=\"{{dvVM.iframeSrc}}\" width=\"100%\" height=\"600px\">\r\n</iframe>"